import { FormattedNumber } from 'react-intl';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

export type SignedScoreVariant = 'positive' | 'negative' | 'neutral';

type Props = {
  signed: boolean;
  variant?: SignedScoreVariant;
  score?: number | null;
};

const COLORS = {
  neutral: 'var(--c-nd-600)',
  positive: 'var(--c-green-300)',
  negative: 'var(--c-red-300)',
};

const Text = styled.span`
  font-family: var(--brand-font);
`;

export const SignedScore = ({ score, signed, variant }: Props) => {
  let color = COLORS.neutral;

  if (variant) {
    if (variant === 'negative' && score === 0) {
      color = COLORS.neutral;
    } else {
      color = COLORS[variant];
    }
  } else if (typeof score === 'number') {
    if (score > 0) {
      color = COLORS.positive;
    } else if (score < 0) {
      color = COLORS.negative;
    }
  }

  const signDisplay = signed ? 'exceptZero' : 'auto';

  return (
    <Text style={{ color } as CSSProperties}>
      {typeof score === 'number' ? (
        <FormattedNumber
          value={score}
          maximumFractionDigits={0}
          signDisplay={signDisplay}
        />
      ) : (
        '-'
      )}
    </Text>
  );
};
